<script>
import appConfig from "@/app.config";
import {pagingModel} from "@/models/pagingModel";
import {required} from "vuelidate/lib/validators";
import {vanBanDenModel} from "@/models/vanBanDenModel";
import {notifyModel} from "@/models/notifyModel";
import {groupCongViecModel} from "@/models/QuanLyCongViec/groupCongViecModel";
import LetterCube from "@/components/LetterCube.vue";
import {CURRENT_USER} from "@/helpers/currentUser";

export default {
  page: {
    title: "Quản lý công việc",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {
    LetterCube,
  },
  data() {
    return {
      title: "Quản lý công việc",
      data: [],
      showModal: false,
      showDetail: false,
      showDeleteModal: false,
      submitted: false,
      model: groupCongViecModel.baseJson(),
      itemFilter: {
        title: null,
        donViSoan: null,
        nguoiSoan: null,
        trangThai: null,
        loaiVanBan: null
      },
      pagination: pagingModel.baseJson(),
      totalRows: 1,
      currentPage: 1,
      numberOfElement: 1,
      perPage: 20,
      pageOptions: [20, 50, 80, 100],
      filter: null,
      isBusy: false,
      sortDesc: false,
      currentUserName: CURRENT_USER.USERNAME,
      fields: [
        {
          key: 'STT',
          label: 'STT',
          thStyle: {width: '30px', minWidth: '30px'},
          class: "text-center content-capso",
          thClass: 'hidden-sortable title-capso',
        },
        {
          key: "code",
          label: "Mã công việc",
          class: "content-capso text-center",
          thStyle: {width: '160px', minWidth: '100px'},
          thClass: "hidden-sortable text-primary",
          sortable: true,
        },
        {
          key: "name",
          label: "Tên công việc",
          thStyle: {width: 'auto', minWidth: '300px'},
          class: "content-capso",
          thClass: 'hidden-sortable title-capso',
          sortable: false,
        },
        {
          key: "ower",
          label: "Người quản lý",
          thStyle: {width: 'auto', minWidth: '100px'},
          class: "content-capso text-center",
          thClass: "hidden-sortable text-primary",
        },
        {
          key: "status",
          label: "Trạng thái",
          thStyle: {width: '100px', minWidth: '100px'},
          class: "text-center",
          thClass: 'hidden-sortable title-capso',
          sortable: false,
        },
        {
          key: 'process',
          label: '',
          thStyle: {width: '150px', minWidth: '150px'},
          class: " text-center btn-process ",
          thClass: 'hidden-sortable title-capso',
          sortable: false,
        }
      ],
      optionsUser: [],
      apiUrl: process.env.VUE_APP_API_URL,
      url: `${process.env.VUE_APP_API_URL}files/upload`,
      urlView: `${process.env.VUE_APP_API_URL}files/view/`,
    };
  },
  validations: {
    model: {
      loaiVanBan: {required},
      trangThai: {required},
    },
  },
  async created() {
    this.getUser();
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    handleThuHoiVanBan(id) {
      this.modelThuHoiId = id;
      this.showThuHoiVanBan = true;
    },
    checkShowSignature(signature, signatureLocal) {
      console.log(signature, signatureLocal)
      if (signature != null || signatureLocal != null) {
        return true;
      }
      return false;
    },
    async getPhanCongKySoByVanBanId(id) {
      this.modelKySo.vanBanDiId = id;
      try {
        await this.$store.dispatch("vanBanDiStore/getPhanCongKySoByVanBanId", id).then(resp => {
          if (resp.resultCode == "SUCCESS") {

            let items = resp.data;
            this.loading = false
            this.listPhanCongKySo = items || [];
            let checkExistPhanCongKySo = this.listPhanCongKySo.find(x => x.userName == this.currentUserName && (x.ngayKyString != null && x.ngayKyString != ""));
            if (checkExistPhanCongKySo != null) {
              this.showButtonKySoCurrent = true;
            } else {
              this.showButtonKySoCurrent = false;
            }
            this.showModalMembers = true;
            return items || []
          }
          return [];
        })
      } finally {
        this.loading = false
      }
    },
    async fnGetList() {
      await this.onPageChange();
    },
    async onPageChange(page = 1) {
      this.$refs.tblList?.refresh()
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.model.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        if (
            this.model.id != 0 &&
            this.model.id != null &&
            this.model.id
        ) {
          //Update model
          await this.$store.dispatch("vanBanDiStore/update", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.showModal = false;
              this.model = vanBanDenModel.baseJson()
              this.$refs.tblList.refresh();
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          })
        } else {
          //Create modelhandleSubmit
          this.model.version = 1;
          await this.$store.dispatch("vanBanDiStore/create", this.model).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.showModal = false;
              this.model = vanBanDenModel.baseJson()
              this.$refs.tblList.refresh();
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          });
        }
        loader.hide();
      }
      this.submitted = false;

    },
    async handleDelete() {
      if (this.model.id != null && this.model.id) {
        await this.$store.dispatch("cvGroupStore/delete", this.model.id).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.showDeleteModal = false;
            this.$refs.tblList.refresh();
          }
        });
      }
    },
    handleDetail(id) {

    },
    async getUser() {
        await this.$store.dispatch("userStore/getAll").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.optionsUser = items;
          }
          return [];
        });
    },
    myProvider(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
        loaiVanBan: this.itemFilter.loaiVanBan,
        trangThai: this.itemFilter.trangThai,
        content: this.itemFilter.title,
        nguoiSoan: this.itemFilter.nguoiSoan,
        donViSoan: this.itemFilter.donViSoan
      }
      this.loading = true

      try {
        let promise = this.$store.dispatch("cvGroupStore/getPagingParams", params)
        return promise.then(resp => {
          let items = resp.data.data
          this.totalRows = resp.data.totalRows
          this.numberOfElement = resp.data.data.length
          this.loading = false
          return items || []
        })
      } finally {
        this.loading = false
      }
    },
    async handleUpdate(id) {
      this.$router.push("quan-ly-cong-viec/nhom-cong-viec/" + id);
    },
    async handleCongViec(id) {
      this.$router.push("tien-do-cong-viec/" + id);
    },
    handleShowDeleteModal(id) {
      this.model.id = id;
      this.showDeleteModal = true;
    },
  }
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="card mb-2">
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-12 d-flex align-items-center">
                <h4 class="font-size-18 fw-bold text-dark"> {{ title }}</h4>
              </div>
              <div class="col-md-8 col-12 text-end">
                <router-link
                    type="b-button sm"
                    to="/quan-ly-cong-viec/nhom-cong-viec"
                    class="btn btn-sm w-md btn-primary"
                    size="sm"
                >
                  <i class="mdi mdi-plus align-middle me-2"></i> Thêm nhóm công việc
                </router-link>
              </div>
            </div>
            <b-collapse id="collapseSearch" class="mt-1">
              <div class="row">
                <div class="col-12">
                  <div class="d-flex justify-content-between align-items-end flex-wrap mb-2">
                    <!-- Nội dung -->
                    <div class="flex-grow-1 me-2">
                      <label>Từ khoá</label>
                      <input
                          size="sm"
                          type="text"
                          name="untyped-input"
                          class="form-control"
                          v-model="itemFilter.title"
                          placeholder="Trích yếu/Số lưu CV/..."
                      />
                    </div>
                    <!-- Đơn vị soạn-->
                    <div class="flex-grow-1 me-2">
                      <label>Đơn vị soạn</label>
                      <multiselect
                          v-model="itemFilter.donViSoan"
                          :options="optionsDonVi"
                          track-by="id"
                          label="ten"
                          placeholder="Chọn đơn vị soạn"
                          deselect-label="Nhấn để xoá"
                          selectLabel="Nhấn enter để chọn"
                          selectedLabel="Đã chọn"
                      ></multiselect>
                    </div>
                    <!-- Loại văn bản -->
                    <div class="flex-grow-1 me-2">
                      <label>Loại văn bản</label>
                      <multiselect
                          v-model="itemFilter.loaiVanBan"
                          :options="optionsLoaiVanBan"
                          track-by="id"
                          selectLabel="Nhấn vào để chọn"
                          deselectLabel="Nhấn vào để xóa"
                          class="helo"
                          label="ten"
                          placeholder="Chọn loại văn bản"
                      ></multiselect>
                    </div>
                    <!--  Xử lý -->
                    <div class="flex-grow-0 ms-2">
                      <div class="d-flex justify-content-between align-items-center flex-wrap">
                        <div class="flex-grow-1 mt-xl-0 mt-2">
                          <b-button @click="handleSearch" variant="light"
                                    class="btn w-md btn-primary me-2" size="md">
                            <i class="fas fa-search align-middle me-2"></i>
                            Tìm kiếm
                          </b-button>
                        </div>
                        <div class="flex-grow-1 mt-xl-0 mt-2">
                          <b-button @click="clearSearch" variant="light"
                                    class="btn w-md btn-secondary me-2" size="md">
                            <i class="fas fa-redo-alt align-middle me-2"></i>
                            Làm mới
                          </b-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <!-- Table -->
                <div class="table-responsive-sm table-responsive">
                  <b-table
                      class="datatables cs-table-vbdi"
                      :items="myProvider"
                      :fields="fields"
                      striped
                      bordered
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      ref="tblList"
                      primary-key="id"
                      :busy.sync="isBusy"
                      tbody-tr-class="b-table-vbd"
                  >
                    <template v-slot:cell(STT)="data">
                      {{ data.index + ((currentPage - 1) * perPage) + 1 }}
                    </template>
                    <template v-slot:cell(name)="data">
                      <div @click="handleCongViec(data.item.id)" style="cursor: pointer">
                        <span v-if="data.item.name"> {{ data.item.name }}</span>
                      </div>

                    </template>
                    <template v-slot:cell(ower)="data">
                      <div v-if="data.item.ower"> {{ data.item.ower.fullName }}</div>
                    </template>
                    <template v-slot:cell(status)="data">
                      <span v-if="data.item.status" class="badge px-2 py-1"
                            :class="'bg-' + data.item.status.bgColor">
                            {{ data.item.status.ten }}
                          </span>
                    </template>
                    <template v-slot:cell(process)="data">
                      <button
                          type="button"
                          class="btn btn-detail btn-sm "
                          data-toggle="tooltip" data-placement="bottom" title="Chi tiết"
                          v-b-toggle="'collapse-' + data.item.id"
                          @click="data.toggleDetails"
                      >
                        <i class="fas fa-eye"></i>
                      </button>

                      <b-dropdown
                          id="dropdown-right"
                          right
                          variant="outline"
                          class="cs-btn-dropdown"
                          menu-class="dropdown-menu-end"
                      >
                        <template v-slot:button-content>
                          ...
                        </template>
                        <b-dropdown-item
                            v-if="currentUserName == data.item.createdBy"
                            v-on:click="handleUpdate(data.item.id)"
                        >
                          <div
                              class="d-flex align-items-center">
                            <button
                                type="button"
                                size="sm"
                                class="btn btn-sm btn-edit"
                                data-toggle="tooltip" data-placement="bottom" title="Cập nhật">
                              <i class="fas fa-pencil-alt"></i>
                            </button>
                            <span class="ms-2">Chỉnh sửa</span>
                          </div>
                        </b-dropdown-item>

                        <b-dropdown-item
                            v-if="currentUserName == data.item.createdBy"
                            v-on:click="handleShowDeleteModal(data.item.id)"
                        >
                          <div class="d-flex align-items-center">
                            <button
                                type="button"
                                size="sm"
                                class="btn btn-sm btn-delete"
                                data-toggle="tooltip" data-placement="bottom" title="Xóa"
                            >
                              <i class="fas fa-trash-alt"></i>
                            </button>
                            <span class="ms-2">Xóa</span>
                          </div>
                        </b-dropdown-item>
                      </b-dropdown>
                    </template>
                    <template #row-details="data">
                      <b-collapse :id="`collapse-${data.item.id}`">
                        <b-card class="show-detail-vbd cs-close-tabs">
                          <button
                              type="button"
                              size="sm"
                              class="btn btn-outline btn-sm p-0 item-close-tabs"
                              data-toggle="tooltip" data-placement="bottom" title="Chi tiết"
                              v-b-toggle="'collapse-' + data.item.id"
                              @click="data.toggleDetails"
                          >
                            <i class="fas fa-plus me-1 item-icon fs-3 text-danger"></i>
                          </button>
                          <b-tabs content-class="p-3 bg-white">
                            <b-tab active class="border-0">
                              <template v-slot:title>
                                <span class="d-inline-block d-sm-none">
                                  <i class="fas fa-file-alt"></i>
                                </span>
                                <span class="d-none d-sm-inline-block">Thông tin</span>
                              </template>
                              <div class="row">
                                <div class="col-lg-6 col-md-6 col-sm-12">
                                  <div v-if="data.item.name" class="d-flex justify-content-between mb-1">
                                    <p class="mb-0 text-primary"> Nhóm công việc:</p>
                                    <p class="mb-0 fw-medium text-black-2a"> {{ data.item.name }}</p>
                                  </div>
                                  <div v-if="data.item.ower" class="d-flex justify-content-between mb-1">
                                    <p class="mb-0 text-primary"> Người tạo: </p>
                                    <p class="mb-0 fw-medium text-black-2a"> {{ data.item.ower.fullName }}</p>
                                  </div>

                                  <div v-if="data.item.users" class="d-flex justify-content-between mb-1">
                                    <p class="mb-0 text-primary" style="width: 200px">Người tham gia:</p>
                                    <div style="text-align: right">
                                             <span v-for="(value, index ) in data.item.users" :key="index">
                                     {{ value.fullName }} <span v-if="index < data.item.users.length - 1">,</span>
                                    </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </b-tab>
                          </b-tabs>
                        </b-card>
                      </b-collapse>
                    </template>
                  </b-table>
                  <template v-if="isBusy">
                    <div align="center">
                      <LetterCube></LetterCube>
                    </div>
                  </template>
                  <template v-if="totalRows <= 0 && !isBusy">
                    <div align="center">Không có dữ liệu</div>
                  </template>
                </div>
                <div>
                  <div class="row mb-2">
                    <div class="col-sm-12 col-md-6">
                      <div style="display: flex; justify-content: start; align-items: center">
                        <div id="tickets-table_length" class="dataTables_length me-4">
                          <label class="d-inline-flex align-items-center">
                            Hiện
                            <b-form-select
                                class="form-select form-select-sm"
                                v-model="perPage"
                                size="sm"
                                :options="pageOptions"
                            ></b-form-select
                            >&nbsp;dòng
                          </label>
                        </div>
                        <div>Hiển thị {{ numberOfElement }} trên tổng số {{ totalRows }} dòng</div>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-6">
                      <div
                          class="dataTables_paginate paging_simple_numbers float-end">
                        <ul class="pagination pagination-rounded mb-0">
                          <!-- pagination -->
                          <b-pagination
                              v-model="currentPage"
                              :total-rows="totalRows"
                              :per-page="perPage"
                          ></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <b-modal
            v-model="showDeleteModal"
            centered
            title="Xóa dữ liệu"
            title-class="fw-bold fs-5 text-dark"
            no-close-on-backdrop
        >
          <p>
            Dữ liệu xóa sẽ không được phục hồi!
          </p>
          <template #modal-footer>
            <b-button v-b-modal.modal-close_visit
                      size="sm"
                      class="btn btn-outline-info w-md"
                      v-on:click="showDeleteModal = false">
              Đóng
            </b-button>
            <b-button v-b-modal.modal-close_visit
                      size="sm"
                      variant="danger"
                      type="button"
                      class="w-md"
                      v-on:click="handleDelete">
              Xóa
            </b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </div>
</template>
<style>
.title-capso {
  font-weight: bold;
  color: #00568C;

}

.content-capso {
  color: #00568C;
  padding-left: 10px;
}

.capso-container {
  margin-top: 10px;
  display: flex;
  padding: 0px;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}

</style>
<style>


.show-detail-vbd {
  background-color: #e6f0fb;
  border: 1px solid #e6f0fb;
  border-radius: 5px;
  margin: 10px;
}

@media only screen and (max-width: 768px) {
  .show-detail-vbd {
    margin: 0px;
  }
}

.show-detail-vbd .card-body {
  padding: 0;
}

.show-detail-vbd .card-body .nav-tabs .nav-link {
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border: none;
  background: transparent;
  color: #055E8F;
  border-radius: 5px;
}

.show-detail-vbd .card-body .nav-tabs .nav-link.active {
  background: #055E8F;
  color: #fff;
}

.show-detail-vbd .card-body .nav-tabs {
  border-bottom: none;
}

.text-black-2a {
  color: #2a2a2a;
}

.text-black {
  color: #000;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}

@media only screen and (max-width: 768px) {

  /* Force table to not be like tables anymore */
  .cs-table-vbdi table,
  .cs-table-vbdi thead,
  .cs-table-vbdi tbody,
  .cs-table-vbdi th,
  .cs-table-vbdi td,
  .cs-table-vbdi tr {
    display: block;
    padding: 5px 0px !important;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  .cs-table-vbdi thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .cs-table-vbdi  tr {
    border: 1px solid #f5f5f5;
    margin-bottom: 5px;
  }

  .cs-table-vbdi  .table-bordered > :not(caption) > * {
    border-width: 0.5px;
    border-radius: 5px;
  }

  .cs-table-vbdi  .table-bordered {
    border: none;
  }

  .cs-table-vbdi  .table-bordered th:first-child,
  .cs-table-vbdi .table-bordered td:first-child {
    border-top: none;
  }

  .cs-table-vbdi .table-bordered th,
  .cs-table-vbdi .table-bordered td {
    border: none;
    border-top: 1px solid #f5f5f5;
  }

  .b-table-vbd > td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    min-height: 30px !important;
    padding-left: 20% !important;
    padding: 5px 0px;
  }

  .b-table-details.b-table-vbd > td {
    padding-left: 0% !important;
  }

  td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 5px;
    left: 6px;
    padding-right: 10px;
    white-space: nowrap;
  }

  .b-table-vbd .btn-process {
    padding: 0px !important;
  }

  .btn-process .btn {
    background-color: rgb(0 89 144 / 0.1);
    width: 20%;
    margin: 5px;
  }

  .file-box {
    flex-direction: column;
  }

  /*
  Label the data
  */
  .b-table-vbd > td:nth-of-type(1):before {
    content: "STT";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(2):before {
    content: "Số VB đi";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(3):before {
    content: "Trích yếu";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(4):before {
    content: "Ngày nhập";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(5):before {
    content: "Ngày ký";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(6):before {
    content: "Trạng thái";
    font-weight: bold;
    color: #00568c;
  }

  .b-table-vbd > td:nth-of-type(7):before {
    content: "";
    font-weight: bold;
    color: #00568c;
  }
}

@media only screen and (max-width: 425px) {
  .b-table-vbd > td {
    padding-left: 25% !important;
  }
}

@media only screen and (max-width: 375px) {
  .b-table-vbd > td {
    padding-left: 30% !important;
  }
}

@media only screen and (max-width: 320px) {
  .b-table-vbd > td {
    padding-left: 35% !important;
  }
}

.cs-close-tabs {
  position: relative;
}

.item-close-tabs {
  position: absolute;
  top: 5px;
  right: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.item-close-tabs:hover {
  background-color: rgba(255, 255, 255, 0.5);
  border-radius: 50px;
  width: 30px;
  height: 30px;
}

.item-icon {
  transform: rotate(135deg);
  color: #fff;
  width: 24px;
  height: 26px;
  position: absolute;
  top: 1px;
  right: -1px;
}

</style>
